module.exports = __webpack_public_path__ + "img/DZ.44eaa886.png";